import { Bar, mixins } from 'vue-chartjs';

export default {
  name: 'bar-chart',
  mixins: [mixins.reactiveProp],
  extends: Bar,
  props: {
    chartData: {
      type: Object,
      default: null,
    },
    options: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      delayed: false,
    };
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
  },
  watch: {
    chartData() {
      this.$data._chart.update();
    },
  },
};
